// extracted by mini-css-extract-plugin
module.exports = {"customerItem":"profilecustomer_customerItem__1dNc8","customerItemIcon":"profilecustomer_customerItemIcon__7lIqX","customerItemActive":"profilecustomer_customerItemActive__1GCcD"};